import * as Sentry from '@sentry/react-router';
import { startTransition, StrictMode } from 'react';

if (import.meta.env.DEV) {
  import('react-grab');
}
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || '',
  release: import.meta.env.VITE_GITHUB_SHA,
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react-router/configuration/options/#sendDefaultPii
  sendDefaultPii: true, // IP/UA を紐づけるなら
  // 統合設定
  integrations: [
    Sentry.reactRouterTracingIntegration(), // ルーティングの自動トレース
    Sentry.replayIntegration(), // セッションリプレイ（任意）
  ],
  // セッションリプレイのサンプリング設定（任意）
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development',
  debug: import.meta.env.VITE_SENTRY_DEBUG === 'true',
});

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
  );
});
